import { Common } from '~/models/common';
import { Employee } from '~/models/employee';

export namespace Benefits {
	export const collection = 'benefits';
	export const api = `/api/${collection}`;

	export const BenefitSize = {
		XS: 1,
		SM: 2,
		MD: 3,
		LG: 4,
		XL: 5,
	} as const;

	export const BenefitType = {
		BENEFIT: 'benefit',
		EMPLOYEE: 'employee',
	} as const;

	export type BenefitTypeBenefit = {
		type: typeof BenefitType.BENEFIT;
		benefit: string;
		benefitText: string;
	};

	export type BenefitTypeEmployee = {
		type: typeof BenefitType.EMPLOYEE;
		employee: Employee.Model;
	};

	export type Model = Common.Model &
		(BenefitTypeBenefit | BenefitTypeEmployee) & {
			size: (typeof BenefitSize)[keyof typeof BenefitSize];
			type: (typeof BenefitType)[keyof typeof BenefitType];
		};

	export const modelState: Model = {
		...Common.modelState,
		size: BenefitSize.SM,
		type: BenefitType.BENEFIT,
		benefit: '',
		benefitText: '',
	};
}
